const extraConfig = {
  shadowColor: {
    property: 'shadowColor',
    scale: 'colors',
  },
  shadowOpacity: {
    property: 'shadowOpacity',
    scale: 'opacities',
  },
  shadowRadius: {
    property: 'shadowRadius',
    scale: 'radii',
  },
  shadowOffset: true,
  elevation: true,
  paddingHorizontal: {
    property: 'paddingHorizontal',
    scale: 'space',
  },
  paddingVertical: {
    property: 'paddingVertical',
    scale: 'space',
  },
  marginHorizontal: {
    property: 'marginHorizontal',
    scale: 'space',
  },
  marginVertical: {
    property: 'marginVertical',
    scale: 'space',
  },
  borderTopStartRadius: {
    property: 'borderTopStartRadius',
    scale: 'radii',
  },
  borderTopEndRadius: {
    property: 'borderTopEndRadius',
    scale: 'radii',
  },
}

export { extraConfig }
